export * from './local-storage.service';
export * from './session-storage.service';
export * from './storage.service';


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/services/cache/index.ts